export default "<ul>\n  <li class=\"li-1\"><p>Hello</p></li>\n  <li>\n    <span style=\"color: red;\">\n      Hello\n    </span>\n  </li>\n</ul>";